import { playUiClick } from '../../../../../assets/preloadSounds';
import './GoBackButton.css';
import flashImg from '../button/flash.png';
import arrowImg from './arrow_icon.png';

type GoBackButtonProps = {
  onClick?: () => void;
};

/** From Figma button_back_arrow (118:19) → Rectangle + Ellipse 30 + arrow. */
export function GoBackButton({ onClick }: GoBackButtonProps) {
  return (
    <button
      type="button"
      className="go-back-button"
      aria-label="Назад"
      onClick={() => {
        playUiClick();
        onClick?.();
      }}
    >
      <img
        className="go-back-button__flash"
        src={flashImg}
        alt=""
        draggable={false}
      />
      <img
        className="go-back-button__arrow"
        src={arrowImg}
        alt=""
        draggable={false}
      />
    </button>
  );
}
